import { render, staticRenderFns } from "./equipment_edit.vue?vue&type=template&id=5736c224&scoped=true"
import script from "./equipment_edit.vue?vue&type=script&lang=js"
export * from "./equipment_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5736c224",
  null
  
)

export default component.exports